// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./SpoqaHanSansNeo-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./SpoqaHanSansNeo-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./SpoqaHanSansNeo-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./SpoqaHanSansNeo-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./SpoqaHanSansNeo-Thin.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SpoqaHanSansNeo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-style: normal;
  font-weight: 700;
  font-display: swap;
}

@font-face {
  font-family: "SpoqaHanSansNeo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-style: normal;
  font-weight: 600;
  font-display: swap;
}

@font-face {
  font-family: "SpoqaHanSansNeo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-style: normal;
  font-weight: 500;
  font-display: swap;
}

@font-face {
  font-family: "SpoqaHanSansNeo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

@font-face {
  font-family: "SpoqaHanSansNeo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
  font-style: normal;
  font-weight: 300;
  font-display: swap;
}
`, "",{"version":3,"sources":["webpack://./src/styles/assets/fonts/fonts.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,2DAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2DAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2DAAyD;EACzD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2DAAuD;EACvD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,2DAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: \"SpoqaHanSansNeo\";\n  src: url(\"./SpoqaHanSansNeo-Bold.woff\") format(\"woff\");\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"SpoqaHanSansNeo\";\n  src: url(\"./SpoqaHanSansNeo-Medium.woff\") format(\"woff\");\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"SpoqaHanSansNeo\";\n  src: url(\"./SpoqaHanSansNeo-Regular.woff\") format(\"woff\");\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"SpoqaHanSansNeo\";\n  src: url(\"./SpoqaHanSansNeo-Light.woff\") format(\"woff\");\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"SpoqaHanSansNeo\";\n  src: url(\"./SpoqaHanSansNeo-Thin.woff\") format(\"woff\");\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
